<div class="btn-group">
  <button
    type="button"
    class="btn btn-actions btn-actions--position btn-just-icon p-0 btn-sm mx-1 hvr-shrink descripcion-emergente-govco bottom"
    data-bs-toggle="dropdown"
    data-bs-auto-close="outside"
    aria-expanded="false"
    id="dropdownAlertasButton"
    aria-label="Ver alertas de trámites">
    <span class="tiptext">{{"visualizar_alertas.alerta_tramites" | translate}}</span>
    <div class="notification-icon d-flex flex-row align-items-center">
      <span class="govco-svg govco-bell icos__nav__user"></span>
      <span
        class="position-absolute top-0 start-100 translate-middle badge badge__Notifications rounded-pill bg-danger">
        {{ countAlertas }}
        <span class="visually-hidden">{{"visualizar_alertas.alertas_sin_leer" | translate}}</span>
      </span>
    </div>
  </button>

  <div
    id="dropdownAlertas"
    class="dropdown-menu dropdown-menu-end"
    data-bs-auto-close="outside"
    aria-labelledby="dropdownAlertasButton">
    <div class="d-flex flex-column p-3 dropdown__alertas">
      <div class="flex-grow-1 w-100 mt-3 overflow-y-scroll">
        <div
          class="row justify-content-evenly my-2 text-center border border-1">
          <div class="col-2"><strong>{{"visualizar_alertas.marca_tiempo" | translate}}</strong></div>
          <div class="col-4"><strong>{{"visualizar_alertas.mensaje_exito" | translate}}</strong></div>
          <div class="col-4"><strong>{{"visualizar_alertas.proceso_entidad" | translate}}</strong></div>
        </div>
        <div
          class="row justify-content-evenly my-2 border border-1"
          *ngIf="countAlertas == 0">
          <div class="col-12 text-center">{{"visualizar_alertas.no_alertas" | translate}}</div>
        </div>
        <div
          class="row justify-content-evenly my-2 border border-1"
          *ngFor="let alerta of alertas">
          <div class="col-2 text-center">
            {{ alerta.Fecha_Creacion | date: 'dd/MM/yyyy HH:mm' }}
          </div>
          <div class="col-4">
            {{ alerta.Titulo }}
          </div>
          <div class="col-4">
            {{ alerta.Detalle }}
          </div>
        </div>
        <div
          class="row justify-content-center my-3"
          *ngIf="this.pagina <= totalPaginas">
          <button
            type="button"
            class="btn btn-govco fill-btn-govco"
            style="width: fit-content"
            (click)="filtrarAlertas()"
            aria-label="Cargar más alertas">
            {{"visualizar_alertas.cargar_mas" | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
